<template>
  <!-- DUPLICATED from packages/frontend for the studio (intentional — see
       docs/superpowers/specs/2026-06-01-battleplan-authoring-tool-design.md §5).
       Keep rendering in sync with the frontend original when it changes. -->
  <div class="keywords-bar">
    <KeywordBadge
      v-for="kw in props.keywords"
      :key="kw"
      :keyword="kw"
      :has-monster-keyword="hasMonsterKeyword"
    />
  </div>
</template>
<script setup lang="ts">
// DUPLICATED from packages/frontend for the studio (intentional — see
// docs/superpowers/specs/2026-06-01-battleplan-authoring-tool-design.md §5).
// Keep rendering in sync with the frontend original when it changes.
import { computed } from 'vue';
import KeywordBadge from './KeywordBadge.vue';
import { hasKeyword } from '@scrolldex/shared';
const props = defineProps<{ keywords?: string[] | null }>();

const hasMonsterKeyword = computed(() => {
  return hasKeyword('monster', props.keywords ?? []);
});
</script>
<style scoped>
.keywords-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
